export const noWebbitToken = `0.0.0`;
/**
 * `RequestContext` token query parameter name on `DevvitPost.entrypointUrl`.
 */
export const tokenParam = 'token';
